import type { Order } from "~/types/order";

const authdFetch = async (url: string, method: string, body?: object) => {
  const { $authdFetch } = useNuxtApp();
  return await ($authdFetch as any)(url, method, body);
};

export const getStripeCustomerSessionClientSecret = async () => {
  const runtimeConfig = useRuntimeConfig();
  const billingApiUrlBase = runtimeConfig.public.fbfBillingApiUrlBase;
  const url = `${billingApiUrlBase}/customers/customer-session-client-secret`;
  const data = await authdFetch(url, 'GET');
  return data;
};

export const startBeesphoneSoloWithNumberSubscription = async (reservedNumberInventoryId: string, numberRegistrationId: string) => {
  const runtimeConfig = useRuntimeConfig();
  const billingApiUrlBase = runtimeConfig.public.fbfBillingApiUrlBase;
  const url = `${billingApiUrlBase}/orders`;
  const data = await authdFetch(url, 'POST', { numberRegistrationId, reservedNumberInventoryId });
  return data;
}

export const getStripeCustomerPortalSessionUrl = async () => {
  const runtimeConfig = useRuntimeConfig();
  const billingApiUrlBase = runtimeConfig.public.fbfBillingApiUrlBase;
  const url = `${billingApiUrlBase}/customers/customer-portal-session-url`;
  const data = await authdFetch(url, 'GET');
  return data;
}

export const getOrders = async () => {
  const runtimeConfig = useRuntimeConfig();
  const billingApiUrlBase = runtimeConfig.public.fbfBillingApiUrlBase;
  const url = `${billingApiUrlBase}/orders`;
  const data = await authdFetch(url, 'GET');
  return data as Order[];
}

export const unsubscribeOrder = async (orderId: string) => {
  const runtimeConfig = useRuntimeConfig();
  const billingApiUrlBase = runtimeConfig.public.fbfBillingApiUrlBase;
  const url = `${billingApiUrlBase}/orders/${orderId}/unsubscribe`;
  const data = await authdFetch(url, 'POST');
  return data as Order;
}